import { flag } from "components/providers/featureFlags/flagUtils";

export type FeatureFlags = typeof featureFlags;
export type FeatureFlagsWidened = Record<string, ReturnType<typeof flag[keyof typeof flag]>>;

export const featureFlags = {
    "Expand Recent Cards": flag.boolean(false),
    "Sponsor tab": flag.boolean(true),
    "Crew Deals": flag.boolean(true)
};
